module.exports = __webpack_public_path__ + "static/media/shed-large.95729639.webp";